<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
<div class="grey-page">
	<section class="container">
    Loading...
	</section>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import * as Auth0Lib from '@/libs/auth0';

export default {
  props: ['auth'],
  created: function() {
    Auth0Lib.handleAuthentication();
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Auth0.vue